import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { logger } from "@/utils/logger";
import { buildOwnProfileInsert } from "@/utils/clientWrites";

export function useUserProfileData() {
  const { data: profileData, isLoading, refetch } = useQuery({
    queryKey: ["user-profile-data"],
    queryFn: async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session?.user) throw new Error("No user found");

      // Buscar o perfil do usuário
      const { data: profile, error: profileError } = await supabase
        .from("profiles")
        .select("*")
        .eq("id", session.user.id)
        .maybeSingle();

      if (profileError) {
        logger.error("Erro ao buscar perfil:", profileError);
        throw profileError;
      }
      
      let userProfile = profile;
      
      // Se não houver perfil, criar um
      if (!userProfile) {
        const { data: newProfile, error: insertError } = await supabase
          .from("profiles")
          .insert(buildOwnProfileInsert({
            id: session.user.id,
            email: session.user.email || "",
          }))
          .select()
          .single();
          
        if (insertError) {
          logger.error("Erro ao criar perfil:", insertError);
          throw insertError;
        }
        userProfile = newProfile;
      }

      // Buscar dados da carta mais recente para preencher informações
      const { data: letterData, error: letterError } = await supabase
        .from("letters")
        .select("whatsapp")
        .eq("email", session.user.email)
        .order("created_at", { ascending: false })
        .limit(1)
        .maybeSingle();

      if (letterError) {
        logger.error("Erro ao buscar dados da carta:", letterError);
      }

      // Combinar dados do perfil com os da última carta
      const finalProfile = {
        ...userProfile,
        whatsapp: letterData?.whatsapp || userProfile.whatsapp || "",
      };

      return finalProfile;
    },
  });

  // A lógica de 'isActive' agora se baseia diretamente no plano do usuário
  const isActive = profileData?.plan_type === 'premium';

  // Verificar se é admin
  const { data: userRole } = useQuery({
    queryKey: ["user-role"],
    queryFn: async () => {
      const { data: role } = await supabase.rpc('get_current_user_role');
      return role || 'user';
    },
  });

  return {
    profileData,
    userRole,
    isLoading,
    isActive,
    refetchProfile: refetch,
  };
}